import { apiClient } from '../../../../api/axios';
import type { ApiResponse } from '../common/types';
import type { TetfundApprovalItem } from './types';

export const tetfundApprovalService = {
    getCurrentApprovals: async (): Promise<ApiResponse<TetfundApprovalItem[]>> => {
        const response = await apiClient.get('/TetfundSubmissionApproval/GetCurrentApproval');
        return response.data;
    },

    bulkApproveSubmissions: async (): Promise<ApiResponse<string>> => {
        const response = await apiClient.post('/TetfundSubmissionApproval/TetfundBulkSubmissionApprove');
        return response.data;
    },
};
